import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconExcel = memo(({ color = '#fff', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        fillRule="nonzero"
        d="M21.17 3.25c.22 0 .417.083.59.25.16.16.24.353.24.58v15.84a.79.79 0 01-.24.58.827.827 0 01-.59.25H7.83a.827.827 0 01-.59-.25.79.79 0 01-.24-.58V17H2.83a.846.846 0 01-.59-.24.846.846 0 01-.24-.59V7.83c0-.22.08-.417.24-.59.173-.16.37-.24.59-.24H7V4.08c0-.227.08-.42.24-.58a.827.827 0 01.59-.25M7 13.06l1.18 2.22h1.79L8 12.06l1.93-3.17H8.22L7.13 10.9l-.04.06-.03.07c-.173-.353-.36-.71-.56-1.07a32.08 32.08 0 00-.53-1.07H4.16l1.89 3.19L4 15.28h1.78m8.1 4.22V17H8.25v2.5m5.63-3.75v-3.12H12v3.12m1.88-4.37V8.25H12v3.13M13.88 7V4.5H8.25V7m12.5 12.5V17h-5.62v2.5m5.62-3.75v-3.12h-5.62v3.12m5.62-4.37V8.25h-5.62v3.13M20.75 7V4.5h-5.62V7h5.62z"
      />
    </Svg>
  );
});
